import get from 'lodash/get';
import head from 'lodash/head';

const getMin = val => head(/[^m]*/.exec(val));

export const getDeliverooTime = info => {
  const estimatedTimeStart = get(info, ['estimated_duration', 'begin'], 0);
  const estimatedTimeEnd = get(info, ['estimated_duration', 'end'], 0);

  const estimatedTimeStartMin = getMin(estimatedTimeStart);
  const estimatedTimeEndMin = getMin(estimatedTimeEnd);
  if (estimatedTimeStartMin === estimatedTimeEndMin) return estimatedTimeStartMin;
  return `${estimatedTimeStartMin}-${estimatedTimeEndMin}`;
};
